/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import "./Manage.scss"
import classnames from "classnames";
import {
  Card,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  Row
} from "reactstrap";
import Three from "../../../assets/images/product-three-dot.png"
import "nouislider/distribute/nouislider.css";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { deleteProduct, getProducts as onGetProducts, } from "../../../live-slices/products/thunk";
import { Price } from "./EcommerceProductCol";
import ProductImage from "../../../assets/images/orderProduct.jpg"
import Eyesblue from "../../../assets/images/eyeBlueIcon.jpg"


import deletIcon from "../../../assets/images/deleteIcon.svg";
import editIcon from "../../../assets/images/editIcon.svg";
import ViewIcon from "../../../assets/images/viewicon.svg";
//Import data
// import { productsData } from "../../../common/data";

//Import actions

//redux
import PaginatedTable from "Components/Common/PaginatedTable";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { createSelector } from "reselect";
import { getAuthMe, updateProductMainToggle, updateProductToggle } from "slices/thunks";
import { Constant } from "utils/enums";
import { getProducts, postRefreshAuth } from "helpers/backend_helper";
import CallTab from "../../../assets/images/AddCallTab.png"
import index from "pages/Landing/NFTLanding";
// import productDate from "utils/productDate";
import moment from "moment";
import TermsPrivacyPopup from "Components/Common/termAndConditions";
import InfiniteScroll from "react-infinite-scroll-component";

const productStatuses = [
  { label: "All", value: "all", countKey: "allCount", count: 0 },
  { label: "Active", value: "active", countKey: "activeCount", count: 0 },
  { label: "Pending", value: "pending", countKey: "pendingCount", count: 0 },
  {
    label: "In Active",
    value: "inactive",
    countKey: "inActiveCount",
    count: 0,
  },
];

const EcommerceProducts = (props: any) => {
  document.title = "Products | BuyPass";
  const dispatch: any = useDispatch();
  const selecteCountData = createSelector(
    (state: any) => state.Product,
    (Ecommerce) => Ecommerce?.counts
  );
  const counts = useSelector(selecteCountData);
  const [tabs, setTabs] = useState<any[]>(productStatuses);
  const [activeTab, setActiveTab] = useState<any>(productStatuses[0].value);
  const [productDate, setProductDate] = useState<any>();
  const [deleteModal, setDeleteModal] = useState<any>({ show: false, id: null });
  const [dele, setDele] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [productStates, setProductStates] = useState<{ [key: string]: boolean }>({});
  const [searchKeyword, setSearchKeyword] = useState("");
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const [activePopover, setActivePopover] = useState<string | null>(null);
  const [folderDeleteId, setFolderDeleteId] = useState('');
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>("https://firebasestorage.googleapis.com/v0/b/cnc-hospital-7f706.appspot.com/o/product%2F17349772213011730417744070__publicwebbg_1730417748023.jpg?alt=media&token=1da9ee57-22d2-4e11-b5d4-f9c354e7c95e");
  const [deleteFolderModal, setDeleteFolderModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [termAndConditonModal, setTermAndConditonModal] = useState(false);
  const [productDataMobile, setProductDataMobile] = useState<any[]>([]);
  const isMobile = window.innerWidth <= 768;
  const [hasMore, setHasMore] = useState(true);


  const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user
  );

  const user = useSelector(selectUser);


  useEffect(() => {
    let pageTabs = [...tabs];
    for (let tab of pageTabs) {
      if (counts) {
        tab.count = counts[tab.countKey] ?? 0;
      }
    }
    setTabs(pageTabs);
  }, [counts]);



  const toggleTab = (tab: any) => {
    if (activeTab !== tab.value) {
      setActiveTab(tab.value);
    }
  };

  const fetchAuthData = async () => {
    dispatch(getAuthMe());
  };

  const navigate = useNavigate();

  useEffect(() => {
    try {
      let refreshToken = localStorage.getItem(Constant.refresh_token);

      if (refreshToken) {
        postRefreshAuth()
          .then((res: any) => {
            if (res && res.access_token) {
              localStorage.setItem(
                Constant.access_token,
                JSON.stringify(res.access_token)
              );
              localStorage.setItem(
                Constant.refresh_token,
                JSON.stringify(res.refresh_token)
              );
            } else {
              handleTokenExpiration();
            }
          })
          .catch((e) => {
            console.log(e);
            handleTokenExpiration();
          });
      } else {
        handleTokenExpiration();
      }
    } catch (e) {
      console.log(e);
    }

    fetchAuthData();
  }, [dispatch]);

  const handleTokenExpiration = () => {
    localStorage.removeItem(Constant.access_token);
    localStorage.removeItem(Constant.refresh_token);
    // toast.error("Token Expired");
    window.location.reload();
  };

  const [selectedCount, setSelectedCount] = useState<string[]>([]);

  //   const handleCheckboxChange = (e : any) => {
  //   if (e.target.checked) {
  //     setSelectedCount(prev => prev + 1);
  //   } else {
  //     setSelectedCount(prev => prev - 1);
  //   }
  // };
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, productId: string) => {
    const isChecked = e.target.checked;

    setSelectedProductIds((prevSelected: string[]) => {
      if (isChecked) {
        return [...prevSelected, productId];
      } else {
        return prevSelected.filter((id) => id !== productId);
      }
    });
  };

  const isSpecialPriceActive = (specialPrice: any) => {
    if (!specialPrice || !specialPrice.startDate || !specialPrice.endDate) return false;

    const now = moment();
    const start = moment(specialPrice.startDate);
    const end = moment(specialPrice.endDate);

    return now.isBetween(start, end, null, '[]');
  };



  const handleMouseEnter = (folderId: string) => {
    setActivePopover(folderId); // Open popover on hover
  };

  const handleMouseLeave = () => {
    setActivePopover(null); // Close popover when mouse leaves
  };

const fetchProductData = async (keyword = "", page = currentPage) => {
  try {
    setLoading(true);

    const res = await dispatch(onGetProducts({
      page,
      count: itemsPerPage,
      status: activeTab,
      keyword,
    }));

    const newData = res.payload?.data || [];
    const total = res.payload?.totalCount || 0;

    setTotalCount(total);

    if (isMobile) {
      setProductDataMobile(prev =>
        page === 1 ? newData : [...prev, ...newData]
      );
      const totalFetched = (page - 1) * itemsPerPage + newData.length;
      setHasMore(totalFetched < total);
    }else{
      setProductDate(newData)
    }
  } catch (error) {
    console.error("Error fetching products:", error);
  } finally {
    setLoading(false);
  }
};


const fetchNextPage = () => {
  console.log("Fetching next page:", currentPage + 1, "Has more:", hasMore);
  if (!hasMore) return;

  const nextPage = currentPage + 1;
  setCurrentPage(nextPage);
  fetchProductData("", nextPage);
};


useEffect(() => {
  setCurrentPage(1);
  if (isMobile) {
    setProductDataMobile([]);
  } else {
    setProductDate([]);
  }
  fetchProductData("", 1);
}, [activeTab,]);


  useEffect(() => {
    fetchProductData();
  }, [currentPage, itemsPerPage, activeTab]);


  useEffect(() => {
    if (Array.isArray(productDate)) {
      const initialStates: { [key: string]: boolean } = {};
      productDate.forEach((item: any) => {
        initialStates[item?._id] = item?.isAvailability;
      });
      setProductStates(initialStates);
    }
  }, [productDate, productDataMobile]);

  const Toggle = (cell: any) => {
    const [isChecked, setIsChecked] = useState(cell.getValue());
    const toggleChange = () => {
      const newToggleState = !isChecked;
      setIsChecked(newToggleState);
      const productId = cell.row.original._id;
      dispatch(
        updateProductToggle({ productId, isAvailability: newToggleState })
      );
    };


    // useEffect(() => {
    //   fetchProductData(searchKeyword);
    // }, [currentPage, itemsPerPage, activeTab]);


    return (
      <React.Fragment>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isChecked}
            data-testing-Id={"activeToggle_manageProducts" + cell.row.index}
            onChange={toggleChange}
          />
        </div>
      </React.Fragment>
    );
  };

  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element") as HTMLElement;
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // const columns = useMemo(() => [
  //   {
  //     header: "Product Info",
  //     accessorKey: "nameEn",
  //     enableColumnFilter: false,
  //     cell: (cell: any) => (
  //       <>


  //         <div
  //           className="d-flex align-items-center">
  //           <div className="flex-shrink-0 me-3">
  //             <Link to={`/product/${cell.row.original._id}`} state={{ product_id: cell.row.original._id }} className="text-primary d-inline-block" data-testing-Id={"ProductDetail_manageProducts" + cell.row.index} >
  //               <div className="avatar-sm bg-light rounded-4 d-flex justify-content-center align-items-center" style={{ width: '80px', height: '80px' }}>
  //                 <img
  //                   src={cell?.row?.original && cell?.row?.original?.variants[0] && cell?.row?.original?.variants[0].value?.images[0] && cell?.row?.original?.variants[0].value?.images[0]?.url || cell.row?.original?.image}
  //                   alt=""
  //                   className="img-fluid d-block rounded-4 "
  //                   style={{ width: '75px', height: '75px' }}
  //                 />
  //               </div>
  //             </Link>
  //           </div>
  //           <div className="flex-grow-1">
  //             <Link to={`/product/${cell.row.original._id}`} state={{ product_id: cell.row.original._id }} className="text-primary d-inline-block" data-testing-Id={"ProductDetail_manageProducts" + cell.row.index} >

  //               <h5 className="fs-14 mb-1">
  //                 {cell.getValue()}
  //               </h5>
  //               <p className="text-muted mb-0">
  //                 Product SKU :{" "}
  //                 <span className="fw-medium">
  //                   {cell.row.original.sellerSKU ? cell.row.original.sellerSKU : "-"}
  //                 </span>
  //               </p>
  //             </Link>

  //             <div className="d-flex align-items-center gap-3 mt-1">
  //               <div className="d-flex align-items-center gap-1" title="The total number of views on product page in the last 30 days, regardless of SKU variations.">
  //                 <i className='bx bxs-cart text-dark fs-5' data-testing-id={'addCartIcon_manageProducts' + cell.row.index}></i>
  //                 <span className="fs-12  text-secondary"> {cell.row.original.viewsCount} </span>
  //               </div>

  //               <div className="d-flex align-items-center gap-1" title="The total number of views on product page in the last 30 days, regardless of SKU variations.">
  //                 <i className='bx bxs-heart text-danger fs-5' data-testing-id={'addHeartIcon_manageProducts' + cell.row.index}></i>
  //                 <span className="fs-12 text-secondary"> {cell.row.original.wishlist} </span>
  //               </div>


  //             </div>
  //           </div>
  //         </div>

  //       </>
  //     ),
  //   },
  //   {
  //     header: "Price",
  //     accessorKey: "price",
  //     enableColumnFilter: false,
  //     cell: (cell: any) => {
  //       const rowData = cell.row.original;
  //       const price = Number(rowData.price);
  //       const specialPrice = rowData.specialPrice;

  //       const now = new Date();

  //       const isSpecialPriceValid =
  //         specialPrice &&
  //         specialPrice.startDate &&
  //         specialPrice.endDate &&
  //         new Date(specialPrice.startDate) <= now &&
  //         new Date(specialPrice.endDate) >= now;

  //       if (isSpecialPriceValid) {
  //         return (
  //           <div style={{ display: "flex", flexDirection: "column-reverse" }}>
  //             <span style={{ textDecoration: "line-through", marginRight: "10px" }}>
  //               Rs {price.toLocaleString("en-US", { maximumFractionDigits: 0 })}
  //             </span>
  //             <span className="text-success fw-bold">
  //               Rs {Number(specialPrice?.amount).toLocaleString("en-US", { maximumFractionDigits: 0 })}
  //             </span>
  //           </div>
  //         );
  //       }

  //       return <div>Rs {price.toLocaleString("en-US", { maximumFractionDigits: 0 })}</div>;
  //     },
  //   }

  //   ,
  //   {
  //     header: "Stock",
  //     accessorKey: "stock",
  //     enableColumnFilter: false,
  //   },
  //   {
  //     header: "Category",
  //     accessorKey: "category",
  //     enableColumnFilter: false,
  //   },
  //   {
  //     header: "City",
  //     accessorKey: "city",
  //     enableColumnFilter: false,
  //     cell: (cellProps: any) => {
  //       const productData = cellProps.row.original;
  //       return (
  //         <p className="m-0 ">{productData?.seller?.city || "-"}</p>
  //       );
  //     },
  //   },
  //   {
  //     header: "Status",
  //     accessorKey: "status",
  //     enableColumnFilter: false,
  //     cell: (cell: any) => {
  //       const statusValue = cell.getValue();
  //       if (statusValue && typeof statusValue === "string") {
  //         const formattedStatus = statusValue.charAt(0).toUpperCase() + statusValue.slice(1);
  //         return <span>{formattedStatus}</span>;
  //       }
  //       return <span>-</span>;
  //     },
  //   },
  //   {
  //     header: "Variants",
  //     accessorKey: "variants",
  //     enableColumnFilter: false,
  //     cell: (cell: any) => {
  //       const variants = cell.getValue();
  //       if (!variants || variants.length === 0 || variants === "") {
  //         return <span className="text-muted">No Variants</span>;
  //       }
  //       const allVariantsEmpty = variants.every((variant: { value: { name: string } }) => !variant.value.name);

  //       if (allVariantsEmpty) {
  //         return <span className="text-muted">No Variants</span>;
  //       }

  //       return (
  //         <>
  //           {variants.map((variant: { type: string, value: { name: string } }, index: number) => (
  //             variant.value.name ? (
  //               <div>
  //                 <span key={index} className="badge bg-secondary  fw-bold">
  //                   {variant.type}: {variant.value.name}
  //                 </span>
  //               </div>
  //             ) : null
  //           ))}
  //         </>
  //       );
  //     },
  //   },


  //   {
  //     header: "Available",
  //     accessorKey: "isAvailable",
  //     enableColumnFilter: false,
  //     cell: (cell: any) => {
  //       return <Toggle {...cell} />;
  //     },
  //   },
  //   {
  //     header: "Action",
  //     cell: (cellProps: any) => {
  //       return (
  //         <>
  //           <ul className="list-inline hstack gap-2 mb-0">
  //             <li className="list-inline-item">
  //               <Link
  //                 to={`/product/${cellProps.row.original._id}`}
  //                 state={{ product_id: cellProps.row.original._id }}
  //                 target="_blank"
  //                 className="text-primary d-inline-block"
  //               >
  //                 <img src={ViewIcon} alt="" style={{ width: "20px", height: "20px" }} data-testing-Id={"eyeIcon_manageProducts" + cellProps.row.index} />
  //               </Link>
  //             </li>
  //             <li className="list-inline-item">
  //               <Link
  //                 to={`/product/edit/${cellProps.row.original.productId}`}
  //                 state={{ product_id: cellProps.row.original.productId }}
  //                 className="text-primary d-inline-block"
  //               >
  //                 <img src={editIcon} alt="" style={{ width: "20px", height: "20px" }} data-testing-Id={"editIcon_manageProducts" + cellProps.row.index} />
  //               </Link>
  //             </li>

  //           </ul>
  //         </>
  //       );
  //     },
  //   },
  // ],
  //   []
  // );


  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handleDelete = () => {
    if (deleteModal?.id) {
      dispatch(deleteProduct({ productId: deleteModal.id, navigate }))
        .then(() => {
          fetchProductData();
        });
    }

    setDeleteModal({ show: false, id: null }); // modal close aur id clear
  };

  const getEffectivePrice = (subPro: any) => {
    if (
      subPro.specialPrice &&
      subPro.specialPrice.amount > 0 &&
      subPro.specialPrice.amount < subPro.price
    ) {
      return subPro.specialPrice.amount;
    }
    return subPro.price || 0;
  };

  useEffect(() => {
    console.log(user, "user data")
  }, [user]);

     const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };



  return (
    <div className="page-content page-content-mobile">
      <ToastContainer closeButton={false} limit={1} />
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => setDeleteModal(false)}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <DeleteModal
        show={deleteModal.show}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal({ show: false, id: null })}
      />
      {/* {user?.storeStatus && (
      <TermsPrivacyPopup
        show={!user.storeStatus.isPrivacyPolicyRead}
        onCloseClick={() => setTermAndConditonModal(false)}
        type="terms"
      />
    )} */}


      <Container fluid>
        <BreadCrumb
          title="Manage Products"
          pageTitle="Products"
          pageTitleRoute="/manage-products"
        />
        <Row>
          <Col xl={12} lg={12}>
            <div>
              <Card className="productListRes">
                <div className="card-header border-0 navigatiovCardProDv">
                  <Nav
                    className="nav-tabs-custom card-header-tabs border-bottom-0 align-items-center justify-content-between mt-1"
                    role="tablist"
                  >
                    <div className="row w-100 mb-md-4">
                      {productStatuses.map((status, index) => (
                        <div key={index} className=" col-md-2 text-center">
                          <NavItem>
                            <NavLink
                              className={classnames(
                                { active: activeTab === status.value },
                                "fw-semibold"
                              )}
                              onClick={() => toggleTab(status)}
                              href="#"
                              data-testing-Id={`${status.value}Button_manageProducts`}
                            >
                              {status.label}
                              <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                {status.count}
                              </span>
                            </NavLink>
                          </NavItem>
                        </div>
                      ))}
                    </div>
                  </Nav>
                  <div className="col-auto d-none d-md-block " >
                    <div id="selection-element">
                      <div className="my-n1 d-flex align-items-center text-muted">
                        Select{" "}
                        <div
                          id="select-content"
                          className="text-body fw-semibold px-1"
                        >
                          {dele}
                        </div>{" "}
                        Result{" "}
                        <button
                          type="button"
                          className="btn btn-link link-danger p-0 ms-3"
                          onClick={() => setDeleteModal(true)}
                          data-testing-Id="removebutton_manageProducts"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mobile-show">
                    <div className="serchRow  ">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchKeyword}
                        onChange={(e) => {
                          const newKeyword = e.target.value;
                          setSearchKeyword(newKeyword);
                          if ((window as any).searchTimeout) {
                            clearTimeout((window as any).searchTimeout);
                          }
                          (window as any).searchTimeout = setTimeout(() => {
                            fetchProductData(newKeyword);
                          }, 3000);
                        }}
                      />
                      <div className=" newProductButton">
                        <Link
                          to="/product/add"
                          className="AddNewButton btn btn-light text-dark fw-bold"
                          data-testing-Id="newProductButton_DraftProducts"
                        >
                          <i> <img src={CallTab} alt=""  /></i> Add New Product
                        </Link>
                      </div>
                    </div>
               <div className="d-flex justify-content-center mb-2 mobile-hide">
                   <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="me-2">
                         <option value={20}>20</option>
                         <option value={50}>50</option>
                         <option value={80}>80</option>
                         <option value={100}>100</option>
                       </select>
                   <div className="paginationDv mobile-show ">
                <nav aria-label="Page navigation example">
                  <ul className="pagination detailPagepagi">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        className="page-link"
                        data-testing-id={"pagination" + currentPage}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <i
                          style={{ height: "11px" }}
                          className="bx bxs-left-arrow"
                        ></i>
                      </button>
                    </li>
                   {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                    }).map((page) => (
                      <div>
                        <li
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                          key={page}
                        >
                          <button
                            style={{ height: "26px" }}
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                            data-testing-id={"pagination" + currentPage}
                          >
                            {page}
                          </button>
                        </li>
                      </div>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link orderPg"
                        style={{
                          height: "26px !important",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        <i
                          className="bx bxs-right-arrow"
                          style={{ width: "6px", height: "11px" }}
                        ></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
               </div>
                  </div>
                </div>
                <div className="card-body pt-0 tableProMovbile">
                  {/* <PaginatedTable
                    key={activeTab}
                    columns={columns}
                    divClass="table-responsive mb-1 dataTableItem prodTable"
                    tableClass="mb-0 align-middle table-borderless"
                    theadClass="table-light text-muted"
                    // fetchData={(params) => onFetchData(params)}
                    fetchData={(params) => getProducts(params.pageIndex, params.pageSize, activeTab, params.searchQuery)}
                  ></PaginatedTable> */}

                  <div className="serchRow mobile-hide mb-2">
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchKeyword}
                      onChange={(e) => {
                        const newKeyword = e.target.value;
                        setSearchKeyword(newKeyword);
                        if ((window as any).searchTimeout) {
                          clearTimeout((window as any).searchTimeout);
                        }
                        (window as any).searchTimeout = setTimeout(() => {
                          fetchProductData(newKeyword);
                        }, 500);
                      }}
                    />

        
                    {/* <Link
                                    to="/product/add"
                                    className="btn btn-secondary"
                                    data-testing-Id="newProductButton_DraftProducts"
                                  >
                    <button className="btn btn-secondary"><i className="ri-add-line align-bottom me-1"></i> New Product</button> 
                    </Link> */}
                    <div className="d-flex justify-content-end gap-2">
                      
                      <Link
                        to="/product/add"
                        className="btn btn-secondary"
                        data-testing-Id="newProductButton_DraftProducts"
                      >
                        <i className="ri-add-line align-bottom me-1"></i> New Product
                      </Link>
                      
                    </div>
                  </div>
                  {/* <div className="inputActiveRow">
                    <h3>{selectedProductIds.length} product{selectedProductIds.length !== 1 ? 's' : ''} selected</h3>
                    <button className="btn btn-outline-secondary">Deactive</button>
                    <button className="btn btn-outline-secondary">Delete</button>
                    <button className="btn btn-outline-secondary">Export selected Products</button>
                  </div> */}
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <div className="Main-GridDV mobile-hide">
                      <div className="gridHeaderDv">
                        <div className="hederItem mainInputDv">
                          {/* <input type="checkbox" />  */}
                          Product Info	</div>
                        <div className="hederItem">Price</div>
                        <div className="hederItem">Available	</div>
                        <div className="hederItem">Stock</div>
                        <div className="hederItem">Category	</div>
                        <div className="hederItem">City	</div>
                        <div className="hederItem">Commision</div>
                        <div className="hederItem">Status</div>
                        <div className="hederItem d-flex   justify-content-end">Action	</div>
                      </div>
                      {productDate?.length > 0 ? (
                        productDate.map((item: any, index: any) => {
                          const prices = item.subProducts?.map((subPro: any) => getEffectivePrice(subPro)) || [];
                          const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
                          const maxPrice = prices.length > 0 ? Math.max(...prices) : 0;
                          function getEffectivePrice(subPro: any): number {
                          const now = new Date();
                          const specialPrice = subPro.specialPrice;
                          if (
                            specialPrice &&
                            specialPrice.amount &&
                            specialPrice.startDate &&
                            specialPrice.endDate &&
                            new Date(specialPrice.startDate) <= now &&
                            now <= new Date(specialPrice.endDate)
                          ) {
                            return specialPrice.amount;
                          }

                          return subPro.price || 0;
                        }
                          const totalStock = item.subProducts?.reduce(
                            (acc: any, subPro: any) => acc + (subPro.stock || 0), 0) || 0;


                          return (
                            <div className="gridParents" key={index}>
                              <div className="gridMainChild">
                                <div className="mainChidItem">
                                  <div className='product-Content' onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(`/product/${item.productId}`, '_blank');
                                  }} style={{ cursor: "pointer" }}>
                                    {/* <input
                                  type="checkbox"
                                  onChange={(e) => handleCheckboxChange(e, item.productId)}
                                /> */}
                                    <figure>
                                      <img src={item?.image} alt="" data-testing-id={"product-Image" + index} />
                                    </figure>
                                    <div className='Galaxy'>
                                      <h6 title={item?.nameEn}>{item?.nameEn}</h6>
                                      <div className="iconsDv">
                                        <div className="itemDv" title="The total number of views on product page in the last 30 days, regardless of SKU variations.">
                                          <i className="bx bxs-cart text-dark fs-5"></i> <span className="fs-12 text-secondary">{item?.viewsCount || '0'}</span>
                                        </div>
                                        <div className="itemDv" title="The total number of views on product page in the last 30 days, regardless of SKU variations.">
                                          <i className="bx bxs-heart text-danger fs-5"></i> <span className="fs-12 text-secondary">{item?.wishlist || '0'}</span>
                                        </div>
                                      </div>
                                      <h6
                                        className="m-0 fs-12 d-flex align-items-center gap-1 fw-bold"
                                        style={{ color: "#878a99", fontWeight: 700, letterSpacing: "0.2px" }}
                                      >
                                        <i className="bx bx-store fs-5"></i>
                                        <span style={{ fontWeight: 700 }}>{item?.seller?.name}</span>
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <div className="mainChidItem">
                                  {/* <p>
                                  {(minPrice === 0 && maxPrice === 0)
                                    ? item.price
                                    : `Rs ${minPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })}${minPrice !== maxPrice ? ` - Rs ${maxPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })}` : ''}`
                                  }
                                 </p> */}
                                  <p>
                                    {(minPrice === 0 && maxPrice === 0) ? (
                                      item.price
                                    ) : (
                                      minPrice === maxPrice ? (
                                        `Rs ${minPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })}`
                                      ) : (
                                        <>
                                          Rs {minPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })} -<br />
                                          Rs {maxPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                        </>
                                      )
                                    )}
                                  </p>


                                </div>

                                {/* <div className="mainChidItem"><p>{item?.stock || '0'}</p></div> */}
                                <div className="mainChidItem">
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      data-testing-id={"ManageProduct " + index}
                                      checked={
                                        productStates[item._id] !== undefined
                                          ? productStates[item.productId]
                                          : item.isAvailable
                                      }
                                      onChange={async () => {
                                        const currentState =
                                          productStates[item._id] !== undefined
                                            ? productStates[item._id]
                                            : item.isAvailable;

                                        const newToggleState = !currentState;

                                        setProductStates((prev) => ({
                                          ...prev,
                                          [item._id]: newToggleState,
                                        }));

                                        const res = await dispatch(
                                          updateProductMainToggle({
                                            id: item.productId,
                                            isAvailable: newToggleState,
                                          })
                                        );
                                        if (res?.payload?.isSuccess) {
                                          const response = await dispatch(
                                            onGetProducts({
                                              page: currentPage,
                                              count: itemsPerPage,
                                              status: activeTab,
                                              keyword: "",
                                            })
                                          );
                                          if (response?.payload) {
                                            setProductDate(response.payload.data);
                                          }
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="mainChidItem"><p>{totalStock}</p></div>

                                <div className="mainChidItem"><p className="cateforyText">{item?.category || '--'}</p></div>
                                <div className="mainChidItem"><p>{item?.seller?.city || '--'}	</p></div>
                                <div className="mainChidItem"><p>{item?.commision?.pct || '0'}%</p></div>
                                <div className="mainChidItem text-capitalize"><p>{item?.status || '--'}	</p></div>
                                <div className="mainChidItem ">
                                  <div className="d-flex justify-content-end fs-3 w-100 z-3 ">
                                    <i
                                      id={`hoverPopover-${item._id}`}
                                      className="bx bx-dots-horizontal-rounded me-2 dotRot"
                                      style={{ color: "#CACACA", cursor: "pointer" }}
                                      onMouseEnter={() => handleMouseEnter(item._id)}
                                      onMouseLeave={() => handleMouseLeave()}
                                      data-testing-Id={'threeDotIcon_mediacenter' + index}
                                    ></i>

                                    <Popover
                                      placement="bottom"
                                      isOpen={activePopover === item._id}
                                      target={`hoverPopover-${item._id}`}
                                      trigger="manual"
                                      aria-labelledby={`popover-${item._id}`}
                                    >
                                      <PopoverBody
                                        onMouseEnter={() => handleMouseEnter(item._id)}
                                        onMouseLeave={() => handleMouseLeave()}
                                        className="px-0 py-3"
                                       >
                                        <div className="d-flex flex-column gap-2  mobile-hide">
                                          <div
                                            className="activeItemsPop w-100 px-2"
                                            data-testing-Id='exportURL_mediacenter'
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              window.open(`/product/${item.productId}`, '_blank');
                                            }}
                                           >
                                            <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                              View Detail
                                            </p>
                                          </div>
                                          <div
                                            className="activeItemsPop w-100 px-2"
                                            data-testing-Id="edit_mediacenter"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              navigate(`/product/edit/${item.productId}`);
                                            }}
                                          >
                                            <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                              Edit
                                            </p>
                                          </div>

                                          <div
                                            className="activeItemsPop w-100 px-2"
                                            data-testing-Id="detele_mediacenter"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setDeleteModal({ show: true, id: item.productId });
                                            }}
                                          >
                                            <p className="text-decoration-none text-dark m-0 p-0 cursor-pointer">
                                              Delete
                                            </p>
                                          </div>
                                        </div>
                                      </PopoverBody>
                                    </Popover>
                                  </div>
                                </div>
                              </div>
                              {item?.subProducts?.length > 0 &&
                                item.subProducts.map((subPro: any, subIndex: any) => {
                                  const firstVariant = subPro?.variants?.[0];
                                  const secondVariant = subPro?.variants?.[1];
                                  const imageUrl = firstVariant?.value?.images?.[0]?.url || secondVariant?.value?.images?.[0]?.url || item?.image;
                                  const colorName = firstVariant?.value?.name || '';
                                  const storageName = secondVariant?.value?.name || '';
                                  const sku = subPro?.sellerSKU || '';
                                  const productSku = item?.productSku || '';

                                  return (
                                    <div className="gridMainChild" key={`sub-${subIndex}`}>
                                      <div className="mainChidItem">
                                        <div className="product-Content margnLeftDv" >
                                          <figure className="itemsChildeImg" onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(`/product/${item.productId}`, '_blank');
                                          }} style={{ cursor: "pointer" }}>
                                            <img src={imageUrl} alt={colorName} data-testing-id={"image-product" + index} />
                                          </figure>
                                          <div className="Galaxy">
                                            <h6>{colorName} , {storageName}</h6>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                              <p>
                                                SKU : <span>{productSku}-{sku}</span>
                                              </p>
                                              <i
                                                className="bx bx-copy text-secondary cursor-pointer"
                                                onClick={() => {
                                                  const fullSku = productSku?.replace(/^P-/, "");
                                                  navigator.clipboard.writeText(fullSku);
                                                  toast.success('SKU copied to clipboard!', {
                                                    autoClose: 1000,
                                                  });
                                                }}
                                                title="Copy SKU"
                                              ></i>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="mainChidItem">
                                        {isSpecialPriceActive(subPro?.specialPrice) ? (
                                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ color: 'green', fontWeight: 'bold' }}>
                                              Rs {Number(subPro?.specialPrice?.amount).toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                            </span>
                                            <span style={{ textDecoration: 'line-through', color: '#888' }}>
                                              Rs {Number(subPro?.price).toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                            </span>
                                          </div>
                                        ) : (
                                          <p>
                                            Rs {Number(subPro?.price || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                          </p>
                                        )}
                                      </div>

                                      <div className="mainChidItem">
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            data-testing-id={"ManageCategory " + index}
                                            type="checkbox"
                                            checked={
                                              productStates[subPro._id] !== undefined
                                                ? productStates[subPro._id]
                                                : subPro.isAvailable
                                            }
                                            onChange={() => {
                                              const currentState =
                                                productStates[subPro._id] !== undefined
                                                  ? productStates[subPro._id]
                                                  : subPro.isAvailable;

                                              const newToggleState = !currentState;

                                              setProductStates((prev) => ({
                                                ...prev,
                                                [subPro._id]: newToggleState,
                                              }));

                                              dispatch(
                                                updateProductToggle({
                                                  productId: subPro._id,
                                                  isAvailability: newToggleState,
                                                })
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="mainChidItem"><p>{subPro?.stock || '0'}</p></div>

                                      <div className="mainChidItem"></div>
                                      <div className="mainChidItem"></div>
                                      <div className="mainChidItem"></div>
                                    </div>
                                  );
                                })}
                            </div>
                          );
                        })
                      ) : (
                        <p className=" text-center fs-5 fw-bold">No data found</p>
                      )}
                    </div>
                  )}

<div className="mobile-show ResponsiveProductCard" id="scrollableMobileDiv">
            {isMobile ? (
  <div>
    <InfiniteScroll
    dataLength={productDataMobile.length}
  next={fetchNextPage}
  hasMore={hasMore}
  loader={<p>Loading...</p>}
      endMessage={<></>}
    >
       {productDataMobile?.length > 0 ? (
                      productDataMobile.map((item: any, index: number) => {
                        // Find the first subProduct for price/stock/sku, or fallback to item
                        const subPro = item.subProducts?.[0] || {};
                        const imageUrl =
                          subPro?.variants?.[0]?.value?.images?.[0]?.url ||
                          subPro?.variants?.[1]?.value?.images?.[0]?.url ||
                          item?.image ||
                          ProductImage;
                        const category = item?.category || '--';
                        const title = item?.nameEn || '--';
                        const sku = item?.productSku || '';
                        const subSku = subPro?.sellerSKU || '';
                        const fullSku = sku && subSku ? `${sku}-${subSku}` : sku || subSku || '--';
                        const price = subPro?.price || item?.price || 0;
                        const specialPrice = subPro?.specialPrice?.amount;
                        const specialStart = subPro?.specialPrice?.startDate;
                        const specialEnd = subPro?.specialPrice?.endDate;
                        const now = moment();
                        const isSpecial =
                          specialPrice &&
                          specialStart &&
                          specialEnd &&
                          now.isBetween(moment(specialStart), moment(specialEnd), null, '[]') &&
                          specialPrice < price;
                        const qty = subPro?.stock ?? item?.stock ?? 0;
                        // Discount calculation
                        let discount = '';
                        if (isSpecial && price > 0) {
                          discount = `-${Math.round(((price - specialPrice) / price) * 100)}%`;
                        }
                        // Stock status
                        let stockStatus = '';
                        if (qty === 0) stockStatus = 'Out of Stock';
                        else if (qty < 10) stockStatus = 'Low Stock';
                        else stockStatus = 'In Stock';

                        return (
                          <div className="product-card" key={item.productId || index}>
                            <div className="sku">SKU: {fullSku}</div>
                            <div className="product-info">
                          
                              <div className="product-image-container">
                                  <img src={imageUrl} alt={title} className="product-image"   onClick={(e) => {
                                              e.stopPropagation();
                                              window.open(`/product/${item.productId}`, '_blank');
                                            }}  />
                                <div className="product-details">

                                 <div className="category">{category}</div>
                                  <div className="title">{title}</div>
                                  <div className="price-info">
                                  <span className="new-price">
                                    Rs.{' '}
                                    {isSpecial
                                      ? Number(specialPrice).toLocaleString('en-US', { maximumFractionDigits: 0 })
                                      : Number(price).toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                  </span>
                                  <div className="d-flex justify-content-between align-items-center">
                                    {isSpecial ? (
                                      <div className="old-price-discount">
                                        <span className="old-price">
                                          Rs. {Number(price).toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                        </span>
                                        <span className="discount">{discount}</span>
                                      </div>
                                    ) : null}
                                  </div>
                                  </div>
                                </div>
                              </div>
                              <div className="status">
                                <span className={qty === 0 ? 'out-stock' : qty < 10 ? 'low-stock' : 'instock'}>
                                  {stockStatus}
                                </span>
                                <div className="qty">QTY: {qty}</div>
                              </div>
                            </div>
                            <div className="popover-actions">

                            <div className="button-group">
                              <button className="btn btn-blue"  onClick={(e) => {
                                              e.stopPropagation();
                                              navigate(`/product/edit/${item.productId}`);
                                            }}>Edit Product</button>
                              <button className="btn btn-red"     onClick={(e) => {
                                              e.stopPropagation();
                                              setDeleteModal({ show: true, id: item.productId });
                                            }}>Delete</button>
                            </div>
                              <div className="">
                                <div>
                                    {/* <i
                                      id={`hoverPopover-mobile-${item._id}`}
                                      className="bx bx-dots-horizontal-rounded me-2 dotRot"
                                      style={{ color: "#CACACA", cursor: "pointer" }}
                                      data-testing-Id={'threeDotIcon_mediacenter' + index}
                                    
                                    ></i> */}
                                    <img src={Three} alt=""   onClick={() => setActivePopover(item._id)}  id={`hoverPopover-mobile-${item._id}`} />
                                    <div className="">
                                      
                                    <Popover
                                      placement="bottom"
                                      className=" mobile-show "
                                      isOpen={activePopover === item._id}
                                      target={`hoverPopover-mobile-${item._id}`}
                                      toggle={() => setActivePopover(activePopover === item._id ? null : item._id)}
                                      trigger="legacy"
                                     >
                                      <PopoverBody>
                                         <div
                                            className="activeItemsPop w-100 px-2"
                                            data-testing-Id='exportURL_mediacenter'
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              window.open(`/product/${item.productId}`, '_blank');
                                            }}
                                           >
                                            <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                              View Detail
                                            </p>
                                          </div>
                                        
                                      </PopoverBody>
                                    </Popover>
                                    </div>
                                </div>

                                  </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-center fs-5 fw-bold">No data found</p>
                    )}

    </InfiniteScroll>
  </div>
) : (
<></>
)}
</div>
  

                  <div className="d-flex ">
                    <div
                      className="paginationDv productPagina mt-4 d-flex justify-content-end"
                      style={{ position: "fixed", bottom: "10px", right: "41px" }}
                     >
                      <nav
                        aria-label="Page navigation example"
                        style={{
                          background: "white",
                          padding: "5px 5px",
                          borderRadius: "4px",
                          border: "1px solid #0877FF",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                         <option value={20}>20</option>
                         <option value={50}>50</option>
                         <option value={80}>80</option>
                         <option value={100}>100</option>
                       </select>
                        <h1
                          style={{
                            color: "#111417",
                            margin: "0px 15px 0px 10px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                          >
                          Total {productDate?.length || 0}
                        </h1>
                        <ul className="pagination detailPagepagi m-0">
                          <li
                            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                          >
                            <button
                              style={{
                                height: "26px",
                                display: "flex",
                                alignItems: "center",
                                border: "none",
                                marginRight: "10px",
                              }}
                              className="page-link"
                              onClick={handlePrevPage}
                            >
                              <i
                                style={{ height: "11px" }}
                                className="bx bxs-left-arrow"
                              ></i>
                            </button>
                          </li>

                          {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                            const startPage = Math.max(
                              Math.min(currentPage - 4, totalPages - 7),
                              1
                            );
                            return startPage + i;
                          }).map((page) => (
                            <li
                              style={{ borderRadius: "10px" }}
                              className={`page-item ${currentPage === page ? "active" : ""
                                }`}
                              key={page}
                            >
                              <button
                                style={{ height: "26px", margin: "0px" }}
                                className="page-link orderPg"
                                onClick={() => handlePageChange(page)}
                              >
                                {page}
                              </button>
                            </li>
                          ))}

                          <li
                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                              }`}
                          >
                            <button
                              className="page-link orderPg"
                              style={{
                                height: "26px",
                                display: "flex",
                                alignItems: "center",
                                border: "none",
                                marginLeft: "10px",
                              }}
                              onClick={handleNextPage}
                            >
                              <i
                                className="bx bxs-right-arrow"
                                style={{ width: "6px", height: "11px" }}
                              ></i>
                            </button>
                          </li>
                           <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>

      <Container fluid style={{ display: "none" }}>
        <BreadCrumb
          title="Manage Products"
          pageTitle="Products"
          pageTitleRoute="/manage-products"
        />

        <button className="btn-add-product">
          <svg
            width="44"
            height="43"
            viewBox="0 0 44 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {" "}
            <path
              d="M31.9813 9.57568L21.9107 4.15716C20.8412 3.58679 19.5757 3.58679 18.5063 4.15716L8.45349 9.57568C7.7227 9.98564 7.25928 10.7699 7.25928 11.6255C7.25928 12.4988 7.70488 13.2831 8.45349 13.6752L18.5241 19.0937C19.0588 19.3789 19.647 19.5215 20.2174 19.5215C20.7878 19.5215 21.3938 19.3789 21.9107 19.0937L31.9813 13.6752C32.7121 13.2831 33.1755 12.4988 33.1755 11.6255C33.1755 10.7699 32.7121 9.98564 31.9813 9.57568Z"
              fill="#0877FF"
            />{" "}
            <path
              d="M16.8665 20.9831L7.50888 16.3132C6.7781 15.9389 5.95819 15.9923 5.26305 16.4023C4.58573 16.8301 4.17578 17.5609 4.17578 18.3629V27.2037C4.17578 28.7366 5.03134 30.109 6.40379 30.8042L15.7614 35.4741C16.0823 35.6345 16.4387 35.7236 16.7952 35.7236C17.2052 35.7236 17.633 35.5988 18.0073 35.3849C18.6846 34.9572 19.0945 34.2264 19.0945 33.4243V24.5835C19.0767 23.0507 18.2212 21.6782 16.8665 20.9831Z"
              fill="#0877FF"
            />{" "}
            <path
              d="M36.2593 18.3629V22.7477C35.4038 22.4981 34.4947 22.3912 33.5857 22.3912C31.1616 22.3912 28.791 23.2289 26.9195 24.7261C24.3528 26.7403 22.8913 29.7882 22.8913 33.0856C22.8913 33.959 22.9982 34.8324 23.2299 35.6701C22.9626 35.6345 22.6952 35.5275 22.4457 35.3671C21.7684 34.9572 21.3584 34.2264 21.3584 33.4243V24.5835C21.3584 23.0507 22.214 21.6782 23.5686 20.9831L32.9262 16.3132C33.657 15.9389 34.4769 15.9923 35.1721 16.4023C35.8494 16.8301 36.2593 17.5609 36.2593 18.3629Z"
              fill="#0877FF"
            />{" "}
            <path
              d="M39.8242 28.0949C39.8242 28.0771 39.8064 28.0593 39.7886 28.0414C39.7173 27.9345 39.6281 27.8276 39.539 27.7384C39.5212 27.7206 39.5034 27.685 39.4855 27.6671C38.0418 26.063 35.9207 25.0648 33.5858 25.0648C31.3399 25.0648 29.2902 25.9917 27.8286 27.4889C26.4205 28.9326 25.5649 30.9111 25.5649 33.0857C25.5649 34.5829 25.9927 36.0088 26.7235 37.2208C27.1156 37.8803 27.6147 38.4863 28.1851 38.9854C28.2207 39.0032 28.2386 39.0211 28.2564 39.0389C28.3455 39.128 28.4346 39.1993 28.5416 39.2884C28.5416 39.2884 28.5416 39.2884 28.5594 39.2884C28.5772 39.3063 28.595 39.3241 28.6129 39.3241C29.9497 40.447 31.6786 41.1065 33.5858 41.1065C36.5089 41.1065 39.0578 39.538 40.448 37.2208C40.858 36.5257 41.1788 35.7593 41.3749 34.9572C41.5353 34.3512 41.6066 33.7273 41.6066 33.0857C41.6066 31.1963 40.9471 29.4495 39.8242 28.0949ZM36.5802 34.3868H34.9226V36.1157C34.9226 36.8465 34.3166 37.4526 33.5858 37.4526C32.855 37.4526 32.249 36.8465 32.249 36.1157V34.3868H30.5913C29.8605 34.3868 29.2545 33.7808 29.2545 33.05C29.2545 32.3192 29.8605 31.7132 30.5913 31.7132H32.249V30.1269C32.249 29.3961 32.855 28.7901 33.5858 28.7901C34.3166 28.7901 34.9226 29.3961 34.9226 30.1269V31.7132H36.5802C37.311 31.7132 37.917 32.3192 37.917 33.05C37.917 33.7808 37.3288 34.3868 36.5802 34.3868Z"
              fill="#FF4F4F"
            />{" "}
          </svg>
          Add New Product
        </button>

        <div className="searchBar">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {" "}
            <path
              d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />{" "}
            <path
              d="M19 19L17 17"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />{" "}
          </svg>
          <input type="text" placeholder="Search" />
        </div>

        <div className="prodtype-list">
          {productStatuses.map((status, index) => (
            <span
              className={status.value === activeTab ? "active" : ""}
              onClick={() => toggleTab(status)}
            >
              <i>{status.count}</i>
              {status.label}
            </span>
          ))}
          {/* <span>All</span>
          <span className="active"><i>20</i>Active</span>
          <span>Inactive</span>
          <span>Pending</span>
          <span>Draft</span>
          <span>Deleted</span>
          <span>Archived</span>
          <span>Rejected</span>
          <span>Unpublished</span> */}
        </div>

        <div className="products-list">
          <h4>Products</h4>

          <div className="product-item">
            <div className="product-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="product-detail">
                <p className="prod-cat">Men's Fashion</p>
                <h5>Retrograph - Espresso</h5>
                <p className="prod-price">Rs. 107,000</p>
                <p className="prod-org-price">
                  <span>Rs. 1,999</span> <b>-66%</b>
                </p>
              </div>
              <div className="prod-stat-det">
                <span className="status lowstock">Low Stock</span>
                <span className="qty">QTY: 40</span>
              </div>
            </div>
            <div className="product-action-row">
              <button className="btn-edit btn-edit-price">Edit Price</button>
              <button className="btn-edit btn-edit-stock">Edit Stock</button>
              <span></span>
              <button className="btn-subaction">
                <i className="mdi mdi-dots-vertical"></i>
              </button>
            </div>
          </div>

          <div className="product-item">
            <div className="product-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="product-detail">
                <p className="prod-cat">Men's Fashion</p>
                <h5>Retrograph - Espresso</h5>
                <p className="prod-price">Rs. 107,000</p>
                <p className="prod-org-price">
                  <span>Rs. 1,999</span> <b>-66%</b>
                </p>
              </div>
              <div className="prod-stat-det">
                <span className="status instock">In Stock</span>
                <span className="qty">QTY: 40</span>
              </div>
            </div>
            <div className="product-action-row">
              <button className="btn-edit btn-edit-price">Edit Price</button>
              <button className="btn-edit btn-edit-stock">Edit Stock</button>
              <span></span>
              <button className="btn-subaction">
                <i className="mdi mdi-dots-vertical"></i>
              </button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EcommerceProducts;
